import React from 'react';

export interface LegendItemProps {
  id: number | string;
  label: string;
  color: string;
}

export const LegendItem = (props: LegendItemProps) => {
  return (
    <div className={'flex mb-2 last-of-type:mb-0 items-center'}>
      <div
        className={'w-2 h-2 mr-1 rounded-full'}
        style={{ backgroundColor: props.color }}
      ></div>
      <div className={'text-sm leading-4'} style={{ color: props.color }}>
        {props.label}
      </div>
    </div>
  );
};
